<wl-minimal-sticky-header
  [showHelp]="showHelp$ | async"
  [ecmpHeader]="ecmpHeader$ | async"
  [brandLogoLink]="brandLogoLink$ | async"
  (helpRequested)="dispatchHelpAction()"
  (logoClicked)="onLogoClicked()"
></wl-minimal-sticky-header>
